import { Subject } from 'rxjs';

export enum ConnectionState {
  Connecting = 1,
  Connected = 2,
  Reconnecting = 3,
  Disconnected = 4
}

export interface ChannelEvent {
  name?: string;
  channelName?: string;
  timestamp: Date;
  data?: any;
  json?: string;
}

export interface ChannelSubject {
  channel: string;
  subject: Subject<ChannelEvent>;
}

export interface NotificationMessage {
  id?: string;
  title: string;
  irishTitle?: string;
  description?: string;
  irishDescription?: string;
  creationDate?: string;
  moduleName?: string;
  path?: string;
  userName?: string;
  status?: string;
  dismissed?: boolean;
  read?: boolean;
  error?: string;
}

export enum NotificationViewMode {
  STANDARD,
  RESPONSIVE
}

